import { ThunkType } from "../../../../core/store/reducers";
import createStockFeeApi from "../api/createStockFee";
import updatestockFeeApi from "../api/updateStockFee";
import { setFetchState } from "../stockFeesDataReducer";
import { StockFee } from "../types";

export const upsertStockFee = (stfee: StockFee): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user;
  const result = stfee.id
    ? await dispatch(updatestockFeeApi(userId, stfee))
    : await dispatch(createStockFeeApi(userId, stfee));

  if (result && result.resCode === "OK") {
    dispatch(setFetchState({ type: "successful", result: result.resDesc }));
    return result.resDesc;
  } else {
    dispatch(setFetchState({ type: "error", errorCode: result?.resCode }));
  }
};
